import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex items-center gap-5 lg:gap-13',
    emptyTitleClass: 'max-sm:!mb-6 max-sm:block',
    tab: 'hover:text-secondary-hover text-inactive min-h-10 cursor-pointer whitespace-nowrap transition-colors',
    title:
      'lg:heading-2xl sm:heading-2xl heading-2xl align-top !font-[380] tracking-[2%] sm:!leading-none',
    count: 'sm:heading-s heading-xs align-top'
  },
  variants: {
    active: {
      true: {
        tab: 'text-main hover:text-main'
      }
    }
  }
});
